import { Component, Inject, OnInit } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { FormGroup, FormBuilder } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { StatusConstant } from '../status/status-constant';
import { LoaderService } from '../../shared/loader/loader.service';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
import { DatePipe } from '@angular/common';
import { animate, state, style, transition, trigger } from '@angular/animations';
import * as moment from 'moment';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Observable } from 'rxjs/internal/Observable';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../reusableComponents/confirm-dialog/confirm-dialog.component';
import { MatRadioChange } from '@angular/material/radio';
import { Clipboard } from "@angular/cdk/clipboard";
import { SendEmailNotificationComponent } from '../sendEmailNotification/sendEmailNotification.component';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-snfTasklist',
  templateUrl: './snfTasklist.component.html',
  styleUrls: ['./snfTasklist.component.scss'],
  providers: [DatePipe],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})

export class SNFTasklistComponent implements OnInit {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  formDialog: FormGroup;
  spinner: boolean = false;
  OfficeIDList: any = [];
  myOfficeID: any;
  taskStatusList: any = [] = [];
  completedTaskStatusID: any = 0;
  displayedColumns: string[] = [];
  taskListID: number = 0;
  selectedRecordMoveToArray: any = [] = [];
  showMoveToOption: boolean = false;
  ButtonForMoveTo: boolean = false;
  taskListIDMoveTo: number = 0;
  taskListFolderForMoveTo: any = [] = [];
  taskListsForMoveTo: any = [] = [];
  showAllCheckBoxes = false;
  taskListFolder: any = [] = [];
  selection = new SelectionModel<any>(true, []);
  dueDatetext: string = 'Due Date';
  preoritytext: string = "Priority";
  myTaskText: string = 'All Task';

  preorityArray: any = [];
  isOverDue: boolean = false;
  isDuedate: boolean = false;
  dateFrom: any = null;
  dateTo: any = null;
  IsAssignedToMe: boolean = false;
  IsAssignedToMyRole: boolean = false;
  IsAllTask: boolean = true;
  IsCreatedByMe: boolean = false;
  isMyTaskFilterSelected: boolean = false;
  ShowNoRecordFound: boolean = false;
  taskList: any = [] = [];
  dataSource: any = [] = [];

  statusGroup: FormGroup;

  taskStatusColors = ['#8f8f8f', '#4f66ff', '#fdab3d', '#00c875', '#db241c']
  taskPriorityColors = ['#8f8f8f', '#fdab3d', '#e2445c', '#00c875', '#db241c']

  taskPriorityNameColorCode = [
    {
      val: 1,
      name: 'Lowest',
      color: '#8f8f8f',
      icon: 'keyboard_double_arrow_down'
    },
    {
      val: 2,
      name: 'Low',
      color: '#fdab3d',
      icon: 'keyboard_double_arrow_down'
    },
    {
      val: 3,
      name: 'Medium',
      color: '#1dcd33',
      icon: 'keyboard_double_arrow_up'
    },
    {
      val: 4,
      name: 'High',
      color: '#d31e16bf',
      icon: 'keyboard_double_arrow_up'
    },
    {
      val: 5,
      name: 'Highest',
      color: '#db241c',
      icon: 'keyboard_double_arrow_up'
    }
  ]


  FieldColumnToogle: any = [] = [];
  folderListForID: any = [] = [];
  ToogleColumnFields: any = [] = [];
  folderId: number = 0;
  ShowCustomColumn: boolean = false;
  FieldColumn: any = [] = [];
  showAddGroupButton: boolean = false;
  showCreateGroup: boolean = false;
  pageSizeOptions: number[] = [10, 20, 50, 100];
  paginatorTotalLength: any;
  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    searchValue: '',
  };
  SingleTaskArchived: boolean = false;

  totalTasks: number = 0;

  openTasks: number = 0;
  inProgressTasks: number = 0;
  blockedTasks: number = 0;
  declinedTasks: number = 0;
  completedTasks: number = 0;
  values: string = "";
  showAddGroupButtonCore: boolean = false;
  taskId: number = 0;
  showTaskDetail: boolean = false;
  taskListIDSharedWithMe: number = 0;
  showProcess: boolean = false;
  mainModuleName: string = "Core";
  typeIdForTask: number = 0;
  TypeIdDrp: number = 0;

  typeId: number = 0;
  name: string = "";
  email: string = "";
  imageUrl: string = "";

  constructor(public dialogRef: MatDialogRef<SNFTasklistComponent>,
    private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private coreService: CoreService,
    private toastr: ToastrService, private statusConstant: StatusConstant, @Inject(MAT_DIALOG_DATA) public data: any,
    private loaderService: LoaderService, private dialog: MatDialog,
    private clipboard: Clipboard) {
    this.statusGroup = new FormGroup({});
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices =  JSON.parse(sessionStorage.getItem('officeList') || '[]');
    offices.forEach((oe:any) => {
      this.OfficeIDList.push(oe.officeID)
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
  }

  ngOnInit(): void {
    this.setDisplayedColumns();
    this.getTaskStatus();
    // this.completedTasks = this.data.taskListID.completedTasks;
    if(this.data.taskListID!=undefined){
     this.transactionIDForTask = this.data.transactionID;
     this.name = this.data.name;
     this.email = this.data.email;
     this.imageUrl="";
     this.totalTasks = this.data.taskListID.totalTasks;
     this.OpenTaskListsFromSFNDashboard(this.data.taskListID.tasklistID);
    }else{
       this.ShowNoRecordFound = true;
    }
  }

  setDisplayedColumns() {
    this.displayedColumns = ["taskTitle", "dueDate", "status", "priority", "Action"];
  }

  getTaskStatus() {
    var ReqModel = {
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
    }
    this.loaderService.show();
    this.coreService.taskStatus(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {
          this.taskStatusList = this.responseHolder.data;
          this.taskStatusList.map((data:any) => {
            if (data.taskStatusConstantName == 'blocked') {
              data.taskStatusName = 'Stuck';
            }
          });
          let completedTask = this.taskStatusList.find((m:any) => m.taskStatusConstantName == 'completed');
          if (completedTask !== undefined) {
            this.completedTaskStatusID = completedTask.taskStatusID;
          }
        }
        else {
          this.loaderService.hide();
        }
      }
      else {
        this.loaderService.hide();
      }
    });
  }

  OpenTaskListsFromSFNDashboard(taskListID: number) {
    this.taskListID = taskListID;
    this.selectedRecordMoveToArray = [];
    this.selection.clear();
    this.showMoveToOption = false;
    this.dueDatetext = 'Due Date';
    this.preoritytext = "Priority";
    this.myTaskText = "Task";
    this.getTaskByTaskList();
  }

  getTaskByTaskList() {
    this.completedTasks = 0;
    this.openTasks = 0;
    this.completedTasks = 0;
    this.inProgressTasks = 0;
    this.blockedTasks = 0;
    this.declinedTasks = 0;

    this.dueDatetext = 'Due Date';
    this.isDuedate = false;
    this.isOverDue = false;
    this.dateFrom = null;
    this.dateTo = null;
    this.preoritytext = "Priority";
    this.myTaskText = "Task";
    this.preorityArray = [];
    this.IsAssignedToMe = false;
    this.IsAssignedToMyRole = false;
    this.IsCreatedByMe = false;
    this.IsAllTask = false;
    this.isMyTaskFilterSelected = false;

    this.ShowNoRecordFound = false;
    this.loaderService.show();
    var ReqModel = {
      taskListID: this.taskListID,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: this.databaseId
    }
    this.coreService.GetTaskGroupsByTaskList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.taskList = [];
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {
          this.dataSource = new MatTableDataSource<any>();
          this.myTaskText = response.data.taskListName;
          this.columns = JSON.parse(JSON.stringify(this.columnsCopy));
          if (response.data.taskGroups !== undefined && response.data.taskGroups !== null) {
            response.data.taskGroups = response.data.taskGroups.sort(function (a:any, b:any) {
              return a.groupPosition - b.groupPosition;
            });

            const taskFil = response.data.taskGroups.filter((x:any) => x.tasks.length > 0)
            taskFil.map((data:any) => {
              data.tasks.forEach((state:any) => {
                this.statusGroup.addControl("status" + state.taskId, this.formBuilder.control(''));

                // Check task open 
                if (state.status == 0 || state.status == 1) {
                  this.openTasks++;
                }
                // Check task In-progress 
                if (state.status == 2) {
                  this.inProgressTasks++;
                }
                // Check task stuck/blocked
                if (state.status == 3) {
                  this.blockedTasks++;
                }
                // Check task declined
                if (state.status == 5) {
                  this.declinedTasks++;
                }
                // Check task completed
                if (state.status == 4) {
                  this.completedTasks++;
                }

                if (state.status == 0) {
                  this.statusGroup.controls["status" + state.taskId].setValue(1);
                } else {
                  this.statusGroup.controls["status" + state.taskId].setValue(state.status);
                }
                this.statusGroup.addControl("priority" + state.taskId, this.formBuilder.control(''));

                if (state.priority == 0) {
                  this.statusGroup.controls["priority" + state.taskId].setValue(1);
                } else {
                  this.statusGroup.controls["priority" + state.taskId].setValue(state.priority);
                }
                // if (state.dueDate != null && state.dueDate != undefined && state.dueDate != "") {
                //   //state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
                //   state.dueDate = state.dueDate + '.000Z';
                // }
              })
            })

            response.data.taskGroups.forEach((tg:any) => {

              if (tg.tasks !== undefined && tg.tasks !== null) {
                tg.tasks.forEach((ts:any) => {
                  ts.formLink = this.reSetFormURL(ts.taskId, ts.formLink);
                  if (ts.dueDate != null && ts.dueDate != undefined && ts.dueDate != "") {
                    ts.dueDate = moment(ts.dueDate).local().format('YYYY-MM-DD');
                  }
                });
                tg.tasks = tg.tasks.sort(function (a:any, b:any) {
                  return a.position - b.position;
                });
              }
              this.columns[0].groups.push({
                id: tg.taskGroupId,
                title: tg.taskGroupName == "Undefined" ? 'Default Group' : tg.taskGroupName,
                items: tg.tasks,
                dragDisabled: tg.taskGroupName == "Undefined" ? true : false,
                groupPosition: tg.groupPosition,
                isTriggered: tg.isTriggered,
                groupType: tg.groupType
              });
            });
          }

          this.taskList = response.data.getTaskDetailResponseDTOs;
          this.FieldColumnToogle = response.data.gridSettings;
          this.FieldColumn = response.data.gridSettings;

          if (this.FieldColumn.length > 0) {
            this.FieldColumn = this.FieldColumn.filter((x:any) => x.isDisplay == true);
          }

          if (response.data.taskGroups.length > 0) {
            this.ShowNoRecordFound = false;
          } else {
            this.ShowNoRecordFound = true;
          }
          if (response.data.taskGroups.length > 0) {
            this.ShowNoRecordFound = false;
          } else {
            this.ShowNoRecordFound = true;
          }
        }
        else {
          this.ShowNoRecordFound = true;
          this.taskList = [];
          this.dataSource.data = [];
          this.loaderService.hide();
        }
      }
      else {
        this.paginatorTotalLength = 0;
        this.ShowNoRecordFound = true;
        this.taskList = [];
        this.loaderService.hide();
      }
    });
  }


  reSetFormURL(taskId: any, formURL: any) {
    if (formURL !== '' && formURL != null) {
      const getToken = formURL.split("token=")[1];
      if (getToken !== undefined) {
        const params = decodeURIComponent(getToken);
        const encrptedToken = this.encryptionAlgo.get(this.reusableClass.encryptionKey, params);
        const decryptedToken = JSON.parse(encrptedToken)
        decryptedToken.taskID = taskId
        const jsonString = JSON.stringify(decryptedToken)
        const encryptedToken = this.encryptionAlgo.set(this.reusableClass.encryptionKey, jsonString);
        const encryptedTokenWithEncoding = encodeURIComponent(encryptedToken);
        const finalFormURL = formURL.split("token=")[0] + "token=" + encryptedTokenWithEncoding;
        return finalFormURL;
      }
      return formURL;
    }
  }


/**
 * Get all task rows from all columns and groups
 */
getAllTaskRows(): any[] {

  const rows: any[] = [];

  if (!this.columns || this.columns.length === 0) {
    return rows;
  }

  this.columns.forEach((column: any) => {

    if (!column.groups || column.groups.length === 0) {
      return;
    }

    column.groups.forEach((group: any) => {

      if (!group.items || group.items.length === 0) {
        return;
      }

      group.items.forEach((row: any) => {
        rows.push(row);
      });

    });

  });

  return rows;
}


/**
 * Get task ID
 * Supports both taskId and taskID
 */
getTaskId(row: any): number {

  if (
    row.taskId !== undefined &&
    row.taskId !== null
  ) {
    return row.taskId;
  }

  if (
    row.taskID !== undefined &&
    row.taskID !== null
  ) {
    return row.taskID;
  }

  return 0;
}


/**
 * Check whether all tasks are selected
 */
isAllSelected(): boolean {

  const rows = this.getAllTaskRows();

  if (rows.length === 0) {
    return false;
  }

  return rows.every((row: any) => {

    return this.selection.isSelected(row);

  });
}


/**
 * Check whether some but not all tasks are selected
 *
 * Used for the indeterminate state of
 * the top checkbox.
 */
isSomeSelected(): boolean {

  const rows = this.getAllTaskRows();

  if (rows.length === 0) {
    return false;
  }

  const selectedCount = rows.filter((row: any) => {

    return this.selection.isSelected(row);

  }).length;


  return (
    selectedCount > 0 &&
    selectedCount < rows.length
  );
}


/**
 * Select / Unselect ALL tasks
 */
masterToggle(): void {

  const rows = this.getAllTaskRows();


  // No records
  if (rows.length === 0) {

    this.selection.clear();

    this.selectedRecordMoveToArray = [];

    this.showMoveToOption = false;

    return;
  }


  // --------------------------------
  // ALL SELECTED
  // --------------------------------

  if (this.isAllSelected()) {

    // Unselect all rows
    this.selection.clear();

    // Clear task IDs
    this.selectedRecordMoveToArray = [];

    // Hide Move To
    this.showMoveToOption = false;

    return;
  }


  // --------------------------------
  // SELECT ALL
  // --------------------------------

  // Clear old selection
  this.selection.clear();

  // Clear old task IDs
  this.selectedRecordMoveToArray = [];


  rows.forEach((row: any) => {

    // Select checkbox
    this.selection.select(row);


    // Get task ID
    const taskId = this.getTaskId(row);


    // Add task ID
    if (taskId !== 0) {

      this.selectedRecordMoveToArray.push({

        selectedRecord: taskId

      });

    }

  });


  // Show Move To
  this.showMoveToOption =
    this.selectedRecordMoveToArray.length > 0;
}


/**
 * Individual row checkbox
 */
isAllSelectedRow(
  event: any,
  element: any
): void {

  const taskId = this.getTaskId(element);


  // --------------------------------
  // CHECK ROW
  // --------------------------------

  if (event.checked) {

    // Select row
    this.selection.select(element);


    // Check duplicate
    const exists =
      this.selectedRecordMoveToArray.some(
        (item: any) =>
          item.selectedRecord === taskId
      );


    // Add task
    if (!exists && taskId !== 0) {

      this.selectedRecordMoveToArray.push({

        selectedRecord: taskId

      });

    }

  }


  // --------------------------------
  // UNCHECK ROW
  // --------------------------------

  else {

    // Deselect row
    this.selection.deselect(element);


    // Find task
    const index =
      this.selectedRecordMoveToArray.findIndex(
        (item: any) =>
          item.selectedRecord === taskId
      );


    // Remove task
    if (index !== -1) {

      this.selectedRecordMoveToArray.splice(
        index,
        1
      );

    }

  }


  // --------------------------------
  // SHOW/HIDE MOVE TO
  // --------------------------------

  this.showMoveToOption =
    this.selectedRecordMoveToArray.length > 0;


  // Make sure array is empty when
  // there are no selected records
  if (!this.showMoveToOption) {

    this.selectedRecordMoveToArray = [];

  }

}


/**
 * Clear all selected tasks
 */
clearTaskSelection(): void {

  this.selection.clear();

  this.selectedRecordMoveToArray = [];

  this.showMoveToOption = false;

}

  // /** Whether the number of selected elements matches the total number of rows. */
  // isAllSelected() {
  //   const numSelected = this.selection.selected.length;
  //   const numRows = this.dataSource.data.length;
  //   this.showAllCheckBoxes = !this.showAllCheckBoxes;
  //   return numSelected === numRows;
  //   // const numSelected = this.selection.selected.length;
  //   // const numRows = this.dataSource.data.length;
  //   // this.showAllCheckBoxes = !this.showAllCheckBoxes;
  //   // return numSelected === numRows;
  // }

  // isAllSelectedNew() {
  //   const numSelected = this.selection.selected.length;
  //   let numRows = 0;
  //   this.columns[0].groups.forEach(grp => {
  //     numRows = numRows + grp.items.length;
  //   });
  //   this.showAllCheckBoxes = !this.showAllCheckBoxes;
  //   return numSelected === numRows;
  // }

  // /** Selects all rows if they are not all selected; otherwise clear selection. */
  // masterToggle() {
  //   this.isAllSelected() ?
  //     this.selection.clear() :
  //     this.dataSource.data.forEach((row:any) => {
  //       this.selection.select(row)
  //     });
  //   this.selectedRecordMoveToArray = [];

  //   if (this.selection.selected.length > 0) {
  //     for (let i = 0; i < this.selection.selected.length; i++) {
  //       var taskId;
  //       if (this.selection.selected[i].taskId == undefined) {
  //         taskId = this.selection.selected[i].taskID;
  //       } else {
  //         taskId = this.selection.selected[i].taskId;
  //       }
  //       let ReqModel = {
  //         selectedRecord: taskId
  //       };
  //       this.selectedRecordMoveToArray.push(ReqModel);
  //     }
  //     this.showMoveToOption = true;
  //   }
  //   else {
  //     this.showMoveToOption = false;
  //     this.selectedRecordMoveToArray = [];
  //   }
  // }

  // masterToggleNew() {
  //   this.isAllSelectedNew() ?
  //     this.selection.clear() :
  //     this.columns[0].groups.forEach(grp => {
  //       grp.items.forEach((row:any) => {
  //         this.selection.select(row)
  //       });
  //     });
  //   this.selectedRecordMoveToArray = [];

  //   if (this.selection.selected.length > 0) {
  //     for (let i = 0; i < this.selection.selected.length; i++) {
  //       var taskId;
  //       if (this.selection.selected[i].taskId == undefined) {
  //         taskId = this.selection.selected[i].taskID;
  //       } else {
  //         taskId = this.selection.selected[i].taskId;
  //       }
  //       let ReqModel = {
  //         selectedRecord: taskId//this.selection.selected[i].taskId
  //       };
  //       this.selectedRecordMoveToArray.push(ReqModel);
  //     }
  //     this.showMoveToOption = true;
  //   }
  //   else {
  //     this.showMoveToOption = false;
  //     this.selectedRecordMoveToArray = [];
  //   }
  // }

  // isAllSelectedRow(event:any, element:any) {
  //   var taskId:number=0;
  //   if (element.taskId == undefined) {
  //     taskId = element.taskID;
  //   } else {
  //     taskId = element.taskId;
  //   }
  //   let ReqModel = {
  //     selectedRecord: taskId
  //   };
  //   if (event.checked) {
  //     this.selectedRecordMoveToArray.push(ReqModel);
  //   } else {
  //     let removeIndex = this.selectedRecordMoveToArray.findIndex((itm:any) => itm.selectedRecord === taskId);
  //     if (removeIndex !== -1) this.selectedRecordMoveToArray.splice(removeIndex, 1);
  //   }
  //   if (this.selectedRecordMoveToArray.length > 0) {
  //     this.showMoveToOption = true;
  //   }
  //   else {
  //     this.showMoveToOption = false;
  //     this.selectedRecordMoveToArray = [];
  //   }
  // }

  
  dropGroup(event: CdkDragDrop<string[]>) {
    //Default Group
    // if(event.item.data.title!='Default Group' && event.currentIndex<(this.columns[0].groups.length-1))
    // {
    moveItemInArray(this.columns[0].groups, event.previousIndex, event.currentIndex);
    var newGroup = [];
    newGroup = this.columns[0].groups.filter((x:any) => x.id > 0);

    var itemList = [];
    if (newGroup.length > 0) {
      //newGroup=newGroup.reverse();
      for (var i = 0, len = newGroup.length; i < len; ++i) {
        var obj = {
          position: i + 1,
          taskGroupID: newGroup[i].id,
        }
        itemList.push(obj);
      }
    }
    //return;
    var ReqModel = {
      taskListID: this.taskListID,
      taskGroups: itemList,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
    };
    this.loaderService.show();
    this.coreService.reorderTaskGroup(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.getTaskByTaskList();
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });

  }

  removeGroup(task: any) {
    const message = `Are you sure you want to delete this group and all associated tasks?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var ReqModel = {
            groupID: task.id,
            taskListID: this.taskListID,
            userID: this.currentUser.UID,
            officeID: this.myOfficeID,
            organizationID: Number(this.organizationId),
            officeIDList: this.OfficeIDList,
            databaseID: this.databaseId
          }
          this.loaderService.show();
          this.coreService.removeTaskGroup(ReqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConstant.statusSuccess) {
                this.responseHolder = response;
                this.toastr.success('Group removed successfully.', '', {
                  timeOut: 3000,
                });
                this.loaderService.hide();
                this.getTaskByTaskList();
              } else {
                this.loaderService.hide();
              }
            } else {
              this.loaderService.hide();
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  ChangeGroupType(event: MatRadioChange, task: any, groupType:any) {
    var message:string='';
    if (groupType == 0) {
      message = `Are you sure you want to change group type as normal for this group? and this changed will be set for all previous groups`;
    }
    if (groupType == 1) {
      message = `Are you sure you want to change group type as trigger for this group? and this changed will be set for all next groups`;
    }
    const title = `Confirm`;
    const confirm = `Confirm`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          this.loaderService.show();
          var ReqModel = {
            groupID: task.id,
            taskListID: this.taskListID,
            groupType: groupType,
            userID: this.currentUser.UID,
            officeID: this.myOfficeID,
            organizationID: Number(this.organizationId),
            databaseID: this.databaseId
          }

        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  onChangeGroupName(event: any, group: any) {
    this.values = event.target.value;
    if (this.values == "") {
      this.toastr.warning("Group name can not be blank.", '', {
        timeOut: 3000,
      });
    }
    if (event != undefined && this.values != "") {
      this.loaderService.show();
      var ReqModel = {
        groupID: group.id,
        groupName: this.values,
        position: 1,
        taskListID: this.taskListID,
        userID: this.currentUser.UID,
        officeID: this.myOfficeID,
        organizationID: Number(this.organizationId),
        officeIDList: this.OfficeIDList,
        databaseID: this.databaseId
      }
      //return;
      this.coreService.addEditTaskGroup(ReqModel).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {
            this.toastr.success('Group renamed successfully.', '', {
              timeOut: 3000,
            });
            this.loaderService.hide();
            this.getTaskByTaskList();
          } else {
            this.loaderService.hide();
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  };

  trackByFn(index:any, item:any) {
    return index; // or item.id
  }

  dropItem(event: CdkDragDrop<string[]>) {
    event.item.data.taskGroupId = Number(event.container.id);
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
      //this.dropTable();
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
      //this.dropTable();
    }
  }

  getConnectedList(): any[] {
    return this.columns[0].groups.map((x) => `${x.id}`);
    // return this.columns.map((x) => `${x.id}`);
  }


  markComplete(task: any) {
    if (task.status !== this.completedTaskStatusID)
      this.completeTask(task);
  }

  completeTask(task:any) {
    this.loaderService.show();
    var ReqModel = {
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      TaskID: task.taskId,
      status: this.completedTaskStatusID,
      databaseID: this.databaseId
    }
    this.coreService.UpdateTaskStatus(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          task.status = this.completedTaskStatusID;
          this.toastr.success("Completed successfully.");
          this.OpenTaskListsFromSFNDashboard(this.data.taskListID.tasklistID);
        }
        else {
          this.loaderService.hide();
        }
      }
      else {
        this.loaderService.hide();
      }
    });
  }


  getTaskDetail(task: any) {
    const body = document.body;
    body.classList.add('removeTabarrows');

    if (this.taskListID == 0) {
      this.showAddGroupButtonCore = false;
    }
    if (this.taskListID > 0) {
      this.showAddGroupButtonCore = true;
    }
    if (task.taskId == undefined) {
      this.taskId = task.taskID;
    } else {
      this.taskId = task.taskId;
    }
    this.showTaskDetail = true;
  }

  closeSaveTaskDetail(messages: boolean) {
    this.showTaskDetail = messages;
    if (this.taskListID == 0) {
      //this.getTaskList(this.pageModelData);
    }
    if (this.taskListID > 0) {
      this.getTaskByTaskList();
    }
  }

  showPIntelligence(messages: boolean) {
    this.showProcess = messages;
  }

  MakeTaskRequired(task: any, isRequired:any) {
    this.loaderService.show();
    var ReqModel = {
      taskIDs: [task.taskId],
      isRequired: isRequired,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      databaseID: this.databaseId
    }
    this.coreService.makeTaskRequired(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          task.isRequired = true;
          if (isRequired == true) {
            this.toastr.success("Task required successfully.");
          }
          if (isRequired == false) {
            this.toastr.success("Task unrequired successfully.");
          }
          if (this.taskListID == 0) {
            // this.getTaskList(this.pageModelData);
          } else {
            this.getTaskByTaskList();
          }
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  getAssigne(item: any) {
    const allAssignee = [];
    if (item && item.length > 1) {
      item.forEach((item:any) => {
        if (item.assigneeName) {
          allAssignee.push({ name: item.assigneeName, image: item.imageUrl });
        } else if (item.roleName) {
          allAssignee.push({ name: item.roleName, image: item.imageUrl });
        } else if (item.email) {
          allAssignee.push({ name: item.email, image: item.imageUrl });
        }
      })
    } else {
      if (item[0]?.assigneeName) {
        allAssignee.push({ name: item[0].assigneeName, image: item[0].imageUrl });
      } else if (item[0]?.roleName) {
        allAssignee.push({ name: item[0].roleName, image: item[0].imageUrl });
      } else if (item[0]?.email) {
        allAssignee.push({ name: item[0].email, image: item[0].imageUrl });
      }
    }
    return allAssignee;
  }

  getShortName(fullName:any) {
    if (fullName != undefined) {
      if (fullName.includes(' ')) {
        return fullName
          .split(' ')
          .map((n:any) => n[0])
          .join('');
      }
      return fullName.substring(0, 1);
    }
    return '';
  }

  encryptedUserToken: any;
  userToken: any;
  decodedUserData: any;
  statusUpdated:string="";

  onTaskListStatusChange($event: any, task: any) {
    this.statusUpdated="";
    let requestModal: any;
    this.encryptedUserToken = sessionStorage.getItem("userToken");
    this.userToken = this.encryptionAlgo.get(this.reusableClass.encryptionKey, this.encryptedUserToken);
    this.decodedUserData = jwt_decode(this.userToken);
    const email = this.encryptedUserToken = sessionStorage.getItem("email");

    let taskStatus = [{
      taskID: task.taskId,
      status: $event,
      position: task.position,
      userID: this.currentUser.UID,
      organizationID: 0,
      officeID: 0,
      officeIDList: [0],
      databaseID: 0
    }]

    let ReqModel = {
      taskListID: this.taskListID,
      isUpdateTaskListStatus: false,
      tasks: taskStatus,

      name: this.decodedUserData.Name,
      email: email,
      emailOfPersonDoingTask: email,
      entityTypeAttached: 0, //3C TYPE
      attachedEntityID: 0, // 3C id

      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: Number(this.myOfficeID),
      officeIDList: [0],
      databaseID: 0
    }

    let taskStatusWithFilter = {
      taskID: task.taskId,
      status: $event,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: Number(this.myOfficeID),
      officeIDList: [0],
      databaseID: 0
    }
    if (this.IsAllTask == true || this.IsAssignedToMe == true || this.IsAssignedToMyRole == true || this.IsCreatedByMe == true) {
      this.coreService.UpdateSingleTaskStatus(taskStatusWithFilter).subscribe((response) => {
        if (response != undefined) {
          if (response.status == this.statusConstant.statusSuccess) {
            this.loaderService.hide();
            this.OpenTaskListsFromSFNDashboard(this.data.taskListID.tasklistID);
            this.statusUpdated="StatusUpdated";
            this.toastr.success("Details updated successfully.");
          } else {
            this.loaderService.hide();
            this.toastr.error("Status updated failed.")
          }
        } else {
          this.loaderService.hide();
          this.toastr.success("Status updated failed.")
        }
      });

    } else {
      this.coreService.UpdateTaskOrTaskListstatus(ReqModel).subscribe((response) => {
        if (response != undefined) {
          if (response.status == this.statusConstant.statusSuccess) {
            this.loaderService.hide();
            this.OpenTaskListsFromSFNDashboard(this.data.taskListID.tasklistID);
            this.statusUpdated="StatusUpdated";
            this.toastr.success("Details updated successfully.");
          } else {
            this.loaderService.hide();
            this.toastr.error("Status updated failed.")
          }
        } else {
          this.loaderService.hide();
          this.toastr.success("Status updated failed.")
        }
      });

    }


  }

  getBackground(stat:any) {
    switch (stat) {
      case 1:
        return this.taskStatusColors[0];

      case 2:
        return this.taskStatusColors[1];

      case 3:
        return this.taskStatusColors[2];

      case 4:
        return this.taskStatusColors[3];

      case 5:
        return this.taskStatusColors[4];

      default:
        return "#000000"

    }

  }


  onTaskListPriorityChange($event: any, task: any) {
    this.encryptedUserToken = sessionStorage.getItem("userToken");
    this.userToken = this.encryptionAlgo.get(this.reusableClass.encryptionKey, this.encryptedUserToken);
    this.decodedUserData = jwt_decode(this.userToken);

    var ReqModel = {
      "taskID": task.taskId,
      "priority": $event,
      "userID": this.currentUser.UID,
      "organizationID": Number(this.organizationId),
      "officeID": Number(this.myOfficeID),
      "officeIDList": [
        0
      ],
      "databaseID": 0
    }

    this.coreService.UpdateTaskPriority(ReqModel).subscribe((response) => {

      if (response != undefined) {
        if (response.status == this.statusConstant.statusSuccess) {

          this.loaderService.hide();
          this.toastr.success("Details updated successfully.");

        } else {
          this.loaderService.hide();
          this.toastr.error("Status updated failed.")
        }
      } else {
        this.loaderService.hide();
        this.toastr.success("Status updated failed.")
      }
    });
  }

  closeTask() {
    this.dialogRef.close(this.statusUpdated);
  }

  deleteTask(task:any) {
    const message = `Are you sure you want to delete this task?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var taskId = 0;
          if (task.taskId == undefined) {
            taskId = task.taskID;
          } else {
            taskId = task.taskId;
          }
          var reqModel = {
            taskIds: [taskId],
            userID: this.currentUser.UID,
            officeID: this.myOfficeID,
            organizationID: Number(this.organizationId),
            officeIDList: this.OfficeIDList,
            databaseID: this.databaseId
          }
          this.loaderService.show();
          this.coreService.removeTasks(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConstant.statusSuccess) {
                if (this.taskListID == 0) {
                  //this.getTaskList(this.pageModelData);
                } else {
                  this.getTaskByTaskList();
                }
                this.loaderService.hide();
                this.toastr.success('Task deleted successfully.', '', {
                  timeOut: 3000,
                });
              } else {
                this.loaderService.hide();
                this.toastr.error('Task deletion failed.', '', {
                  timeOut: 3000,
                });
              }
            } else {
              this.loaderService.hide();
              this.toastr.error('Task deletion failed.', '', {
                timeOut: 3000,
              });
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }



  // ======== Archived ============//

  currentTaskListArchived: number = 0;
  taskListSelectedArchived = false;
  taskListsArchived: any = [] = [];
  expandedIndexArchived: number = 0;
  taskListIDArchived: number = 0;
  pageSize: number = 300;
  pageIndex: number = 1;

  ArchiveTask(task:any) {
    this.taskListSelectedArchived = true;
    this.taskListsArchived = [];
    const message = `Are you sure you want to archive this task?`;
    const title = `Confirm`;
    const confirm = `Confirm`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var taskId = 0;
          if (task.taskId == undefined) {
            taskId = task.taskID;
          } else {
            taskId = task.taskId;
          }
          var reqModel = {
            taskIds: [taskId],
            isArchived: true,
            userID: this.currentUser.UID,
            officeID: this.myOfficeID,
            organizationID: Number(this.organizationId),
            officeIDList: this.OfficeIDList,
            databaseID: this.databaseId
          }
          this.loaderService.show();
          this.coreService.archivedTask(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConstant.statusSuccess) {
                if (this.taskListID == 0) {
                  this.pageIndex = 1;
                  this.pageSize = 300;
                  //this.getTaskList(this.pageModelData);
                } else {
                  this.getTaskByTaskList();
                }
                this.loaderService.hide();
                this.toastr.success('Task archived successfully.', '', {
                  timeOut: 3000,
                });
              } else {
                this.loaderService.hide();
                this.toastr.error('Task archived failed.', '', {
                  timeOut: 3000,
                });
              }
            } else {
              this.loaderService.hide();
              this.toastr.error('Task archived failed.', '', {
                timeOut: 3000,
              });
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  openTaskUrl(list:any) {
    let params = decodeURIComponent(list.token);
    const tokenm = this.encryptionAlgo.get(this.reusableClass.encryptionKey, params);
    let decryptedToken = JSON.parse(tokenm);

    //decryptedToken.isOpenURL = false;
    decryptedToken.UserID = this.currentUser.UID;
    const jsonString = JSON.stringify(decryptedToken)
    const encryptedToken = this.encryptionAlgo.set(this.reusableClass.encryptionKey, jsonString);
    const encryptedTokenWithEncoding = encodeURIComponent(encryptedToken);

    let URL = window.location.href.split(window.location.pathname)[0] + "/request/task?token=" + encryptedTokenWithEncoding;
    this.clipboard.copy(URL);
    this.toastr.success("Link Copied Successfully.", '', {
      timeOut: 3000,
    });
  }

  deleteMultipleTask() {
    const message = `Are you sure you want to delete selected task?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var selectedtasklist = [];
          if (this.selectedRecordMoveToArray.length > 0) {
            for (var i = 0, len = this.selectedRecordMoveToArray.length; i < len; ++i) {
              const taskid = this.selectedRecordMoveToArray[i].selectedRecord;
              selectedtasklist.push(taskid);
            }
          }
          var reqModel = {
            taskIds: selectedtasklist,
            userID: this.currentUser.UID,
            officeID: this.myOfficeID,
            organizationID: Number(this.organizationId),
            officeIDList: this.OfficeIDList,
            databaseID: this.databaseId
          }
          this.loaderService.show();
          this.coreService.removeTasks(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConstant.statusSuccess) {
                if (this.taskListID == 0) {
                  // this.getTaskList(this.pageModelData);
                } else {
                  this.getTaskByTaskList();
                }
                this.showMoveToOption = false;
                this.selectedRecordMoveToArray = [];
                this.selection.clear();
                this.loaderService.hide();
                this.toastr.success('Task deleted successfully.', '', {
                  timeOut: 3000,
                });
              } else {
                this.showMoveToOption = false;
                this.selectedRecordMoveToArray = [];
                this.selection.clear();
                this.loaderService.hide();
                this.toastr.error('Task deletion failed.', '', {
                  timeOut: 3000,
                });
              }
            } else {
              this.showMoveToOption = false;
              this.selectedRecordMoveToArray = [];
              this.selection.clear();
              this.loaderService.hide();
              this.toastr.error('Task deletion failed.', '', {
                timeOut: 3000,
              });
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }


  sendManualTaskReminder(task:any) {
    const dialogRef = this.dialog.open(SendEmailNotificationComponent, {
      data: {
        taskListID: task,
      },
      width: '40vw',
      height: 'auto',
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {

      }
    });

  }

  closeTaskDetail(messages: boolean) {
    this.showTaskDetail = messages;
    const body = document.body;
    body.classList.remove('removeTabarrows');
  }

  OpenTaskListinNewTab() {
   sessionStorage.setItem("taskListID", (this.taskListID).toString());
   let tasktab = "/core/documents?&taskListID=" + btoa((this.taskListID).toString())+ "&transactionIDSNF=" + btoa(this.data.transactionID); 
   window.open(tasktab, "_blank");
  }


  columns = [
    {
      id: 0,
      title: "",
      groups: [
        // {
        //   id: 1,
        //   title: 'Group 1',
        //   items: [
        //     {
        //       "completedTaskCount": 1,
        //       "inprogressTaskCount": 2,
        //       "taskId": 839,
        //       "taskTitle": "ewqe",
        //       "dueDate": "2022-12-30T18:30:00",
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-12-30T16:12:20.0127548",
        //       "parentID": 0,
        //       "status": 4,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#db241c",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },
        //   {
        //       "completedTaskCount": 0,
        //       "inprogressTaskCount": 0,
        //       "taskId": 823,
        //       "taskTitle": "Testing add from core",
        //       "dueDate": null,
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-12-14T15:49:37.5893446",
        //       "parentID": 0,
        //       "status": 0,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#B36AE2",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },
        //   {
        //       "completedTaskCount": 0,
        //       "inprogressTaskCount": 0,
        //       "taskId": 822,
        //       "taskTitle": "Testing add from core",
        //       "dueDate": null,
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-12-14T15:49:36.6103009",
        //       "parentID": 0,
        //       "status": 0,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#B36AE2",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },

        //   ],
        // },
        // {
        //   id: 3,
        //   title: 'Group 3',
        //   items: [
        //     {
        //       "completedTaskCount": 0,
        //       "inprogressTaskCount": 0,
        //       "taskId": 820,
        //       "taskTitle": "avv1",
        //       "dueDate": "2022-11-27T18:30:00",
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-11-28T18:12:16.8375494",
        //       "parentID": 0,
        //       "status": 4,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#db241c",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },
        //   {
        //       "completedTaskCount": 0,
        //       "inprogressTaskCount": 0,
        //       "taskId": 349,
        //       "taskTitle": "test neu cores23445",
        //       "dueDate": "2022-11-25T18:30:00",
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-11-25T18:33:58.1130724",
        //       "parentID": 0,
        //       "status": 4,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#db241c",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },
        //   {
        //       "completedTaskCount": 0,
        //       "inprogressTaskCount": 0,
        //       "taskId": 348,
        //       "taskTitle": "Testing add from core234",
        //       "dueDate": "2022-11-24T18:30:00",
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-11-25T18:21:26.8596399",
        //       "parentID": 0,
        //       "status": 4,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#B36AE2",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },

        //   ],
        // },
      ],
    },

  ];

  columnsCopy = [
    {
      id: 0,
      title: "",
      groups: [
        // {
        //   id: 1,
        //   title: 'Group 1',
        //   items: [
        //     {
        //       "completedTaskCount": 1,
        //       "inprogressTaskCount": 2,
        //       "taskId": 839,
        //       "taskTitle": "ewqe",
        //       "dueDate": "2022-12-30T18:30:00",
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-12-30T16:12:20.0127548",
        //       "parentID": 0,
        //       "status": 4,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#db241c",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },
        //   {
        //       "completedTaskCount": 0,
        //       "inprogressTaskCount": 0,
        //       "taskId": 823,
        //       "taskTitle": "Testing add from core",
        //       "dueDate": null,
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-12-14T15:49:37.5893446",
        //       "parentID": 0,
        //       "status": 0,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#B36AE2",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },
        //   {
        //       "completedTaskCount": 0,
        //       "inprogressTaskCount": 0,
        //       "taskId": 822,
        //       "taskTitle": "Testing add from core",
        //       "dueDate": null,
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-12-14T15:49:36.6103009",
        //       "parentID": 0,
        //       "status": 0,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#B36AE2",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },

        //   ],
        // },
        // {
        //   id: 3,
        //   title: 'Group 3',
        //   items: [
        //     {
        //       "completedTaskCount": 0,
        //       "inprogressTaskCount": 0,
        //       "taskId": 820,
        //       "taskTitle": "avv1",
        //       "dueDate": "2022-11-27T18:30:00",
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-11-28T18:12:16.8375494",
        //       "parentID": 0,
        //       "status": 4,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#db241c",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },
        //   {
        //       "completedTaskCount": 0,
        //       "inprogressTaskCount": 0,
        //       "taskId": 349,
        //       "taskTitle": "test neu cores23445",
        //       "dueDate": "2022-11-25T18:30:00",
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-11-25T18:33:58.1130724",
        //       "parentID": 0,
        //       "status": 4,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#db241c",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },
        //   {
        //       "completedTaskCount": 0,
        //       "inprogressTaskCount": 0,
        //       "taskId": 348,
        //       "taskTitle": "Testing add from core234",
        //       "dueDate": "2022-11-24T18:30:00",
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-11-25T18:21:26.8596399",
        //       "parentID": 0,
        //       "status": 4,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#B36AE2",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },

        //   ],
        // },
      ],
    },

  ];

isValidDueDate(date: any): boolean {
  if (!date.dueDate || date.dueDate === 'Invalid date') {
    return false;
  }

  const parsedDate = new Date(date.dueDate);
  return !isNaN(parsedDate.getTime());
}


onTaskFilterChange(event: any): void {

  const selectedStatus = event;

  if (!selectedStatus) {
    return;
  }

  const selectedTasks = this.selection.selected;

  if (selectedTasks.length === 0) {
    this.toastr.warning("Please select at least one task.");
    return;
  }

  this.loaderService.show();

  let completedRequests = 0;
  let failedRequests = 0;

  const updateNextTask = (index: number): void => {

    // All tasks processed
    if (index >= selectedTasks.length) {

      this.loaderService.hide();

      if (failedRequests === 0) {

        this.selection.clear();

        this.toastr.success("All selected tasks updated successfully.");

        this.OpenTaskListsFromSFNDashboard(
          this.data.taskListID.tasklistID
        );

        this.statusUpdated = "StatusUpdated";

      } else {

        this.toastr.error("Some tasks failed to update.");
      }

      return;
    }

    const task = selectedTasks[index];

    const reqModel = {
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      taskID: Number(task.taskId),
      status: Number(selectedStatus),
      databaseID: Number(this.databaseId)
    };

    this.coreService.UpdateTaskStatus(reqModel).subscribe({

      next: (response: any) => {

        if (
          response &&
          response.status === this.statusConstant.statusSuccess
        ) {

          task.status = selectedStatus;
          completedRequests++;

        } else {

          failedRequests++;
        }

        // Process next task
        updateNextTask(index + 1);
      },

      error: (error: any) => {

        failedRequests++;

        // Continue with next task even if this one fails
        updateNextTask(index + 1);
      }
    });
  };

  // Start with first selected task
  updateNextTask(0);
}


// Task action types (see the Action Type select in task-details)
  private readonly actionTypes: { [key: number]: { label: string; icon: string } } = {
    2: { label: 'Form', icon: 'description' },
    3: { label: 'Document', icon: 'upload_file' },
    4: { label: 'Video', icon: 'smart_display' },
    5: { label: 'Link', icon: 'link' },
    6: { label: 'Email', icon: 'mail' },
  };

  taskAction(item: any) {
    return this.actionTypes[item?.action] || null;
  }

  private get allLoadedTasks(): any[] {
    const tasks: any[] = [];
    (this.columns || []).forEach((column: any) => {
      (column.groups || []).forEach((group: any) => {
        (group.items || []).forEach((item: any) => tasks.push(item));
      });
    });
    return tasks;
  }
  
    // "After <task>" chip from scheduleTask; cached per task object
    private dependencyCache = new WeakMap<any, { key: string; value: { title: string; rule: string } | null }>();
  
    taskDependency(item: any): { title: string; rule: string } | null {
      const st = item?.scheduleTask;
      if (!item || !st || !st.dependentTaskID) return null;
  
      const dep = this.allLoadedTasks.find((t: any) => t.taskId == st.dependentTaskID);
      const key = st.dependentTaskID + '|' + (st.scheduleData || '') + '|' + (dep ? dep.taskTitle : '');
      const cached = this.dependencyCache.get(item);
      if (cached && cached.key === key) return cached.value;
  
      const title = dep ? dep.taskTitle : 'another task';
      let rule = 'Starts after "' + title + '"';
      try {
        const d = JSON.parse(st.scheduleData || '{}');
        const anchor = d.trigger == 'completed' ? '"' + title + '" is completed' : '"' + title + '" is due';
        const hasOffset = d.timenumber > 0 && d.timeperiod && d.timeperiod != 'immediately';
        rule = hasOffset
          ? 'Due ' + d.timenumber + ' ' + d.timeperiod + ' ' + (d.afterbefore && d.afterbefore != 'none' ? d.afterbefore : 'after') + ' ' + anchor
          : 'Starts when ' + anchor;
      } catch (e) { }
  
      const value = { title, rule };
      this.dependencyCache.set(item, { key, value });
      return value;
    }

    showCreateTask: boolean = false;
    moduleNames = "3C";
    transactionIDForTask: number = 0;

    createNewTask() {
     this.taskId = 0;
     this.showCreateTask = true;
   }

   getCloseCreateTask() {
    this.showCreateTask = false;
  }

  getSaveTask() {
    // if (this.taskListID == 0) {
    //   this.getTaskList(this.pageModelData);
    // }
    if (this.taskListID > 0) {
     this.OpenTaskListsFromSFNDashboard(this.data.taskListID.tasklistID);
    }
  }

}




